import { AuthService } from '@app/security/shared/authentication.service';
import { Injectable } from '@angular/core';
import { LegacyService } from '@app/legacy/legacy.service';
import { Logger } from '@app/logger/logger';
import { Observable, fromEvent } from 'rxjs';
import { UriService } from '@app/shared/uri.service';
import { WindowRefService } from '@app/shared/window-ref.service';
import { debounceTime, map } from 'rxjs/operators';

export const URL_PARAM_TOKEN = 'tk';
export const URL_PARAM_TOKEN_TYPE = 'tt';
export const URL_PARAM_EXPIRES = 'tkex';
export const URL_PARAM_HIDE_MENU = 'hm';
export const URL_PARAM_CONNECT_TO_CLASSIC = 'ctc';

@Injectable({ providedIn: 'root' })
export class WindowService {
  private currentWindowPinned = false;

  constructor(
    private authService: AuthService,
    private legacyService: LegacyService,
    private log: Logger,
    private uriService: UriService,
    private windowRef: WindowRefService
  ) {}

  public appendTokenCredentialsToUrl(uri: string): string {
    let newUri = uri;

    newUri = this.uriService.appendParameterToUrl(newUri, URL_PARAM_TOKEN, this.authService.token);
    newUri = this.uriService.appendParameterToUrl(
      newUri,
      URL_PARAM_TOKEN_TYPE,
      this.authService.tokenType
    );
    newUri = this.uriService.appendParameterToUrl(
      newUri,
      URL_PARAM_EXPIRES,
      this.authService.expires.toString()
    );

    newUri = this.uriService.appendParameterToUrl(
      newUri,
      URL_PARAM_CONNECT_TO_CLASSIC,
      this.legacyService.isConnectingToClassic() ? '1' : '0'
    );

    return newUri;
  }

  public getTokenUrlForBackgroundWindow(): string {
    const window = this.windowRef.window;

    return this.appendTokenCredentialsToUrl(
      `${window.location.protocol}//${window.location.hostname}:${window.location.port}/bg`
    );
  }

  public openCurrentViewInNewWindow(currentUrl?: string): void {
    let currentUri: string;
    if (currentUrl) {
      currentUri = currentUrl;
    } else {
      currentUri = this.windowRef.window.location.href;
    }

    this.log.info(`user: request to open new window`, currentUri);

    if (
      !currentUri.includes(`${URL_PARAM_TOKEN}=`) &&
      !currentUri.includes(`${URL_PARAM_EXPIRES}=`) &&
      !currentUri.includes(`${URL_PARAM_CONNECT_TO_CLASSIC}=`)
    ) {
      currentUri = this.appendTokenCredentialsToUrl(currentUri);
      currentUri = this.uriService.appendParameterToUrl(currentUri, URL_PARAM_HIDE_MENU, '1');
    }

    this.windowRef.window.open(currentUri);
  }

  public toggleWindowPin(): void {
    this.currentWindowPinned = !this.currentWindowPinned;
    this.log.info(`current window set to ${this.currentWindowPinned ? 'pinned' : 'unpinned'}`);
  }

  public isCurrentWindowPinned(): boolean {
    return this.currentWindowPinned;
  }

  public onWindowResize(): Observable<any> {
    return fromEvent(window, 'resize')
      .pipe(
        map(() => {
          return document.documentElement.clientWidth + ',' + document.documentElement.clientHeight;
        })
      )
      .pipe(debounceTime(250));
  }
}
